import clsx from "classnames";
import { Col, Container, Row } from "react-bootstrap";
import classes from "./styles.module.scss";
import { Description, Title, Video } from "@/ui";
import { DynamicImage } from "@/ui/DynamicImage";
import { Buttons } from "@/ui/Buttons";

export default function NarrativePanel({
  sectionId,
  className,
  bgColor,
  title,
  titleColor,
  description,
  img,
  buttons,
  video_embed_url,
  iframe_embed_code,
  // code_iframe,
  reverse,
}) {
  return (
    <div id={sectionId} className={clsx(className, bgColor, classes.panel)}>
      <Container className="mw-xxl">
        <Row className={clsx("flex-column-reverse", { "flex-md-row-reverse": reverse, "flex-md-row": !reverse })}>
          <Col
            xs={12}
            md={video_embed_url || img || iframe_embed_code ? 6 : 12}
            className="d-flex flex-column justify-content-center"
          >
            <div
              className={clsx({
                "ms-md-5": reverse && (video_embed_url || img),
                "me-md-5": !reverse && (video_embed_url || img),
              })}
            >
              <Title title={title} className={clsx(titleColor, "mb-3")} />
              <Description description={description} />
              <Buttons buttons={buttons} />
            </div>
          </Col>
          <Col xs={12} md={6} className="d-flex flex-column justify-content-center">
            {iframe_embed_code ? (
              <figure className="mb-4 mb-md-0 w-100">
                <div dangerouslySetInnerHTML={{ __html: iframe_embed_code }} />
              </figure>
            ) : video_embed_url ? (
              <Video video_embed_url={video_embed_url} />
            ) : img ? (
              <figure className="mb-4 mb-md-0">
                <DynamicImage className="mw-100 w-100" image={img} />
              </figure>
            ) : null}
          </Col>
        </Row>
      </Container>
    </div>
  );
}
